<template>
    <v-data-table
        fixed-header
        :headers="columns"
        :items="items"
        :items-per-page="-1"
        :hide-default-footer="true"
        :keep-filters="false"
    ></v-data-table>
</template>
<script>
export default {
    props: {
        columns: {
            type: Array,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
    },
};
</script>
